function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M53.3,224C23.9,224,0,247.9,0,277.3V448c0,29.4,23.9,53.3,53.3,53.3h64c12,0,23.1-4.1,32-10.8V224H53.3z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M512,304c0-12.8-5.1-24.8-13.9-33.6c10-10.9,15-25.5,13.7-40.7c-2.5-27.1-26.9-48.4-55.6-48.4H324.4 c6.5-19.8,17-56.1,17-85.3c0-46.3-39.3-85.3-64-85.3c-22.2,0-38,12.5-38.7,13c-2.5,2-4,5.1-4,8.3v72.3l-61.4,133.1l-2.6,1.3v228.7 C188,475.6,210,480,224,480h195.8c23.2,0,43.6-15.7,48.3-37.3c2.5-11.1,1-22.3-3.9-32c15.8-7.9,26.4-24.2,26.4-42.7 c0-7.6-1.7-14.8-5-21.3C501.4,338.7,512,322.5,512,304z"
})));

var SvgThumbsUp = function SvgThumbsUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbs-up.51352725.svg";
export { ForwardRef as ReactComponent };